// eslint-disable-next-line no-unused-vars
import React, { memo, useEffect, useState } from 'react';

import useFetch from 'Hooks/useFetch';
import useUser from 'Hooks/useUser';
// import useNumberUtils from 'Hooks/useNumberUtils';
import useAsyncError from 'Hooks/useAsyncError';
import useAnalytics from 'Hooks/useAnalytics';
import download from 'Utils/download';
import ECommerceToolsComponent from 'Components/APIIntegrations/ECommerceTools';
import { API_ECOMMERCE_TOOLS } from 'Constants';

const ECommerceTools = memo(() => {
  const [eCommerceTools, setECommerceTools] = useState([]);
  const [loading, setLoading] = useState(false);
  const fetcher = useFetch();
  // const { formatDate } = useNumberUtils();
  const throwError = useAsyncError();
  const { data: { email, loggedIn } = {} } = useUser();
  const analytics = useAnalytics();

  const getECommerceTools = () => {
    setLoading(true);

    fetcher(API_ECOMMERCE_TOOLS).then(res => {
      setECommerceTools(res || []);
    }).catch(err => throwError(err))
      .finally(() => setLoading(false));
  };

  useEffect(() => {
    if (loggedIn) {
      getECommerceTools();
    }
  }, [email, loggedIn]);

  const handleDownload = url => {
    analytics.track('download_clicked');
    download(url);
  };

  return (
    <ECommerceToolsComponent
      eCommerceTools={ eCommerceTools }
      loading={ loading }
      handleDownload={ handleDownload }
    />
  );
});

ECommerceTools.displayName = 'ECommerceToolsContainer';

export default ECommerceTools;
